import { IdiomaService } from './../../providers/idioma/idioma.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DiagnosticoService } from '../../providers/diagnostico/diagnostico.service';
import { AuthenticationService } from '../../providers/authentication/authentication.service';
import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';
import { IdiomaCalendario } from '../../domain/IdiomaCalendatio';
import { TranslateService } from 'ng2-translate/src/translate.service';
import { Predicate } from 'breeze-client';
import { BalizaFormulario } from '../../domain/BalizaFormulario';
import { BreadcrumbService } from '../../breadcrumb.service';
import { AppComponent } from '../../app.component';

@Component({
  templateUrl: './Beacons.component.html',
  styles: [`
      .cars-datalist ul {
          margin: 0;
          padding: 0;
      }

      @media (max-width:640px) {
          .cars-datalist .text-column {
              text-align: center;
          }
      }
  `],
  styleUrls: ['./Beacons.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class BeaconsComponent implements OnInit {

	public displayDialog: boolean = true;

	spinner: HTMLElement;
	balizas: any[] = [];
	balizasFiltradas: any[] = [];
	idHardwareBalizas: any[] = [];

	cols_balizas: any[] = [];

	timeout: any;
	nivelBateriaFilter: number;

	idiomaCalendario: IdiomaCalendario ;

	fechaInstalacion_DesdeFilter: Date;
	fechaInstalacion_HastaFilter: Date;

	fechaAlta_DesdeFilter: Date;
	fechaAlta_HastaFilter: Date;

	fechaBaja_DesdeFilter: Date;
	fechaBaja_HastaFilter: Date;

	secciones_filter: string;
	bateria_filter: string;

	timestampLecturaBateria_DesdeFilter: Date;
	timestampLecturaBateria_HastaFilter: Date;

	initOrder: string;

	public tipologiasBaliza = [];
	public tipologiasBalizaSeleccionada = this.tipologiasBaliza[0];
	tipologia_filter: any;

	displayDialogBaliza: boolean = false;
	balizaSeleccionada: BalizaFormulario = new BalizaFormulario();

	constructor(
		private appComponent: AppComponent,
		private translate: TranslateService,
		private breadcrumbService: BreadcrumbService,
		public DIAG: DiagnosticoService,
		public authService: AuthenticationService,
		private entityManager: EntityManagerProvider,
		private idiomaService: IdiomaService,
		public router: Router,
		private route: ActivatedRoute) {
		this.breadcrumbService.setItems([
			{
				label: this.translate.instant('Beacons.beacons')
			}
		]);
		this.cols_balizas = [
			{ field: 'IdHardware', header: this.translate.instant('Beacons.IdHardwareHeader'), visible: true  },
			{ field: 'DescInstalacion', header: this.translate.instant('Beacons.DescripcionHeader'), visible: true   },
			{ field: 'TIPOLOGIA_BALIZA', header: this.translate.instant('Beacons.tipologia'), visible: true }, // clases: ['th-tipo-medio'] },
			{ field: 'TipologiaNombre', header: '', visible: false, width: '0%' },
			{ field: 'NivelBateria', header: this.translate.instant('Beacons.BateriaHeader'), visible: true  },
			// { field: 'potenciaTx', header: this.translate.instant('Beacons.PotenciaHeader'), visible: true  },
			{ field: 'FechaInstalacion', header: this.translate.instant('Beacons.InstalacionHeader'), visible: true  },
			{ field: 'FechaAlta', header: this.translate.instant('Formularios.fechaalta'), visible: true  },
			{ field: 'FechaBaja', header: this.translate.instant('Formularios.fechabaja'), visible: true  },
			{ field: 'TimestampLecturaBateria', header: this.translate.instant('Beacons.UltimaHeader'), visible: true  },
			{ field: 'SECCIONES', header: this.translate.instant('Beacons.SeccionesHeader'), visible: true  }

		];

		this.idiomaCalendario = new IdiomaCalendario();
		this.idiomaCalendario.firstDayOfWeek = 1;
		this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
		this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
		this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
		this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
		this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
		this.idiomaCalendario.today = this.translate.instant('Calendario.today');
		this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');
	}

	ngOnInit() {
		this.obtenerBalizas();
		this.obtenerBalizasTotales();

		this.route.queryParams
			.subscribe(params => {
				this.initOrder = params['order'];
			});
	}

	obtenerBalizas() {
		const that = this;
		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'inherit';
		const idEspacio = that.authService.getIdEspacio();

		// const where = new Predicate ('NODOS', 'any', 'NODO.SECCION.ALA.NIVEL.ESPACIO.Id', '==', idEspacio);
		// const where = new Predicate ('ALA_PLANO.NIVEL.ESPACIO.Id', '==', idEspacio);
		const where = new Predicate ('EspacioPertenencia', '==', idEspacio);
		const includes = 'NODOS.NODO.SECCION.ALA.NIVEL.ESPACIO, ALA_PLANO.NIVEL.ESPACIO, TIPOLOGIA_BALIZA';
		return this.entityManager.getBALIZA(where, includes)
		.then(function(BALIZAs){
			that.balizas = [];
			BALIZAs.forEach(element => {
					const baliza = new BalizaFormulario().fromENTIDAD(element);
					that.balizas.push(baliza);
				});
			that.balizasFiltradas = that.balizas;
				
			return that.obtenerTIPOLOGIA_BALIZA();
		})
		.then(function(tipologias){
			that.spinner.style.display = 'none';
			return true;
		});
	}

	obtenerTIPOLOGIA_BALIZA() {
		const that = this;
		const entityManager = that.entityManager;
		return entityManager.getTIPOLOGIA_BALIZA(undefined, undefined)
			.then(function (entidades) {
				that.tipologiasBaliza = entidades;

				that.tipologiasBaliza = entidades;
				if (that.tipologiasBaliza && that.tipologiasBaliza.length > 0) {
					that.tipologiasBaliza.sort((one: any, two: any) => {
						return one.Nombre > two.Nombre ? 1 : -1;
					});
				}

				const tipologia_todas = {
					Nombre: that.translate.instant('Contenidos.estadoTodos')
				};

				that.tipologiasBaliza.unshift(tipologia_todas);
			});
	}

	obtenerBalizasTotales() {
		const that = this;

		const idEspacio = that.authService.getIdEspacio();

		return this.entityManager.getBALIZA()
		.then(function(BALIZAs){

			BALIZAs.forEach(element => {
					const baliza = new BalizaFormulario().fromENTIDAD(element);
					that.idHardwareBalizas.push(baliza.IdHardware);
				});
				
		});
	}

	getDate(timestamp){
		let fecha = undefined;
		if (timestamp){
			const anio = timestamp.slice(0, 4);
			const mes = timestamp.slice(4, 6) - 1;
			const dia = timestamp.slice(6, 8);
			const hora = timestamp.slice(8, 10);
			const min = timestamp.slice(10, 12);

			fecha = new Date(anio, mes, dia, hora, min);
		}

		return fecha;
	}

	onTipologiaChange(event, dt) {
		this.filtrarTabla(dt, event, 'TIPOLOGIA_BALIZA', 'equals');
	}

	onNivelbateriaChange(event, dt) {
		this.filtrarTabla(dt, event, 'NivelBateria', 'le');
	}

	onFechaChange(dt, event, columna, tipo) {
		// Centralizamos el filtrado
		if (tipo === 'Hasta') {
			if(event){
				event.setHours(23,59,59,0);
			}
		}
		if (tipo === 'Desde') {
			if(event){
				event.setHours(0,0,0,0);
			}
		}
		console.log(event)
		this.filtrarTabla(dt, event, columna, tipo);
	}

	onFechaAceptar(dt, calendar, columna, tipo) {
		console.log(calendar);
		const fecha = calendar.value ? calendar.value : new Date();
		if (tipo === 'Hasta') {
			fecha.setHours(23,59,59,0);
		}
		if (tipo === 'Desde') {
			fecha.setHours(0,0,0,0);
		}
		this.onFechaChange(dt, fecha, columna, tipo);
		calendar.overlayVisible=false;
	}

	onSeccionChange(dt, event, columna, tipo){
		// Centralizamos el filtrado
		this.filtrarTabla(dt, event, columna, tipo);
	}

	filtrarTabla(dt, event, columna, tipo){

		const that = this;
		this.balizasFiltradas = this.balizas;

		// Filtro nivel Bateria
		if (columna === 'NivelBateria') {
			this.bateria_filter = event.value;
			if (tipo === 'le') {
				dt.filter(event.value + 1, columna, 'lt');
			}
			else{
				dt.filter(event.value, columna, tipo);
			}
		}

		// Filtro Tipologia
		if (columna === 'TIPOLOGIA_BALIZA') {
			if (event.value.Nombre !== this.translate.instant('Contenidos.estadoTodos') ) {
				this.tipologia_filter = event.value;
				dt.filter(event.value.Nombre, 'TipologiaNombre', tipo);
			}
			else{
				dt.filter(event.value.Nombre, 'TipologiaNombre', 'notEquals');
			}
		}

		// Preparamos los valores de los filtros
		if (tipo === 'Desde') {
			if (columna === 'FechaInstalacion') {
				this.fechaInstalacion_DesdeFilter = event;
			}
			if (columna === 'FechaAlta') {
				this.fechaAlta_DesdeFilter = event;
			}
			if (columna === 'FechaBaja') {
				this.fechaBaja_DesdeFilter = event;
			}
			if (columna === 'TimestampLecturaBateria') {
				this.timestampLecturaBateria_DesdeFilter = event;
			}
		}

		if (tipo === 'Hasta') {
			if (columna === 'FechaInstalacion') {
				this.fechaInstalacion_HastaFilter = event;
			}
			if (columna === 'FechaAlta') {
				this.fechaAlta_HastaFilter = event;
			}
			if (columna === 'FechaBaja') {
				this.fechaBaja_HastaFilter = event;
			}
			if (columna === 'TimestampLecturaBateria') {
				this.timestampLecturaBateria_HastaFilter = event;
			}
		}
		console.log(that.fechaInstalacion_DesdeFilter)
		console.log(that.fechaInstalacion_HastaFilter)
		// Aplicamos filtro FechaInstalacion
		this.balizasFiltradas = this.balizasFiltradas.filter(function (bal) {
			console.log(bal)
			let flagDesde = true;
			let flagHasta = true;
			if ((that.fechaInstalacion_DesdeFilter === undefined || that.fechaInstalacion_DesdeFilter === null) &&
				(that.fechaInstalacion_HastaFilter === undefined || that.fechaInstalacion_HastaFilter === null)) {
				return true;
			}
			if (that.fechaInstalacion_DesdeFilter !== undefined && that.fechaInstalacion_DesdeFilter !== null ) {
				flagDesde = that.fechaInstalacion_DesdeFilter < bal.FechaInstalacion;
			}
			if (that.fechaInstalacion_HastaFilter !== undefined && that.fechaInstalacion_HastaFilter !== null) {
				flagHasta = that.fechaInstalacion_HastaFilter > bal.FechaInstalacion;
			}
			return flagDesde && flagHasta;
		});

		// Aplicamos filtro FechaAlta
		this.balizasFiltradas = this.balizasFiltradas.filter(function (bal) {
			let flagDesde = true;
			let flagHasta = true;
			if ((that.fechaAlta_DesdeFilter === undefined || that.fechaAlta_DesdeFilter === null) &&
				(that.fechaAlta_HastaFilter === undefined || that.fechaAlta_HastaFilter === null)) {
				return true;
			}
			if (that.fechaAlta_DesdeFilter !== undefined && that.fechaAlta_DesdeFilter !== null ) {
				flagDesde = that.fechaAlta_DesdeFilter < bal.FechaAlta;
			}
			if (that.fechaAlta_HastaFilter !== undefined && that.fechaAlta_HastaFilter !== null) {
				flagHasta = that.fechaAlta_HastaFilter > bal.FechaAlta;
			}
			return flagDesde && flagHasta;
		});

		// Aplicamos filtro FechaBaja
		this.balizasFiltradas = this.balizasFiltradas.filter(function (bal) {
			let flagDesde = true;
			let flagHasta = true;
			if ((that.fechaBaja_DesdeFilter === undefined || that.fechaBaja_DesdeFilter === null) &&
				(that.fechaBaja_HastaFilter === undefined || that.fechaBaja_HastaFilter === null)) {
				return true;
			}
			if (that.fechaBaja_DesdeFilter !== undefined && that.fechaBaja_DesdeFilter !== null ) {
				flagDesde = that.fechaBaja_DesdeFilter < bal.FechaBaja;
			}
			if (that.fechaBaja_HastaFilter !== undefined && that.fechaBaja_HastaFilter !== null) {
				flagHasta = that.fechaBaja_HastaFilter > bal.FechaBaja;
			}
			return flagDesde && flagHasta;
		});

		// Aplicamos filtro TimestampLecturaBateria
		this.balizasFiltradas = this.balizasFiltradas.filter(function (bal) {
			let flagDesde = true;
			let flagHasta = true;
			if ((that.timestampLecturaBateria_DesdeFilter === undefined || that.timestampLecturaBateria_DesdeFilter === null) &&
				(that.timestampLecturaBateria_HastaFilter === undefined || that.timestampLecturaBateria_HastaFilter === null)) {
				return true;
			}
			if (that.timestampLecturaBateria_DesdeFilter !== undefined && that.timestampLecturaBateria_DesdeFilter !== null ) {
				if (bal.TimestampLecturaBateria) {
					flagDesde = that.timestampLecturaBateria_DesdeFilter < that.idiomaService.timastampToDate(bal.TimestampLecturaBateria);
				}
			}
			if (that.timestampLecturaBateria_HastaFilter !== undefined && that.timestampLecturaBateria_HastaFilter !== null) {
				if (bal.TimestampLecturaBateria) {
					flagHasta = that.timestampLecturaBateria_HastaFilter > that.idiomaService.timastampToDate(bal.TimestampLecturaBateria);
				}
			}
			return flagDesde && flagHasta;
		});

		this.balizasFiltradas = this.balizasFiltradas.filter(function (bal) {
			if ((that.secciones_filter === undefined)) {
				return true;
			}
			if (that.secciones_filter !== undefined && that.secciones_filter !== null ) {

				const encontrado = bal.SECCIONES.find( x => x.Nombre.includes(that.secciones_filter));
				if (encontrado) {
					return true;
				}
			}
			return false;
		});
	}

	onBalizaSelect(bal){
		console.log(this.balizaSeleccionada);
		this.balizaSeleccionada.FechaLecturaBateria = this.getDate(this.balizaSeleccionada.TimestampLecturaBateria)
		this.displayDialogBaliza = !this.displayDialogBaliza;
	}

	// FORMULARIO BALIZA

	onBeaconGuardado(event){
		console.log(event)
		const result = event.result;
		if (result === true) {
			this.onFormularioBalizaCerrado(undefined);
			this.appComponent.showSuccess(this.translate.instant('Mapas.contenidoguardadook'));
		}
		else {
			this.appComponent.showError(this.translate.instant('Mapas.contenidoguardadoerror'));
		}
	}

	onBeaconEliminado(event){
		const result = event.result;
		const balizaFormulario: BalizaFormulario = event.element;
		if (result === true) {

			const that = this;
			this.obtenerBalizas()
			.then(() => {
				that.onFormularioBalizaCerrado(undefined);
				that.appComponent.showSuccess(that.translate.instant('Mapas.balizaeliminadook'));
			});


		}
		else {
			this.appComponent.showError(this.translate.instant('Mapas.balizaeliminadoerror'));
		}
	}

	onFormularioBalizaAbierto (evento){
	}

	onFormularioBalizaCerrado(event){

		console.log('onFormularioBalizaCerrado');

		this.desmarcarBalizas();

		if (this.displayDialogBaliza) { //  Descartado
			if (this.balizaSeleccionada.ENTIDAD) {
				// TODO: ver si tenemos que restaurar algun dato tras cerrar sin guardar
			}
		}

		this.displayDialogBaliza = false;
	}

	desmarcarBalizas() {
		console.log('Method not implemented.');
		let dummySelectedRow = Object.assign([], this.balizaSeleccionada);
        dummySelectedRow.splice(0, 1);
        this.balizaSeleccionada = dummySelectedRow;
	}

}




// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/Beacons/Beacons.component.ts